import i18n from "@/i18n";
import { mapActions } from "vuex";
import { dialogTypes } from "@/constants/dialogTypes";
import { SnackbarStyle } from '@/constants/constants'
import { thingService } from "@/services/thing.service";
import { bussinesTargetService } from "@/services/bussinesTarget.service";
import Vue from "vue";
import AgriculturalObjectiveTabComponent from "./tabs/objetive/AgriculturalObjectiveTabComponent.vue"
import EquipmentTabComponent from "./tabs/equipment/EquipmentTabComponent.vue"

export default {
    name: "GoalsDialogComponent",
    components: {
        AgriculturalObjectiveTabComponent,
        EquipmentTabComponent,
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        tab: null,
        objectiveTab: {
            key: "agriculturalObjectiveTab",
            tab: i18n.t("goals.editDialog.tabs.objetive"),
            tooltip: i18n.t("equipment.editDialog.tabs.dataTooltip"),
            icon: "flag",
            content: {
                _uid: "oRWrTpA788",
                component: "AgriculturalObjectiveTabComponent",
                headline: "AgriculturalObjectiveTabComponent",
            },
            disabled: false,
            model: {
                name: null,
                identificator: null,
                color: "#0694de",
                commodatum: false,
                tableData: [],
                validForm: false,
                disabledBtn: false,
                enterpriseId: ''
            },

        },
        equipmentTab: {
            key: "equipmentTab",
            tab: i18n.t("goals.editDialog.tabs.equipment"),
            tooltip: i18n.t("equipment.editDialog.tabs.dataTooltip"),
            icon: "mdi-checkbox-multiple-marked-outline",
            content: {
                _uid: "oRWrTpA799",
                component: "EquipmentTabComponent",
                headline: "EquipmentTabComponent",
            },
            disabled: false,
            model: {
                // datos del árbol
                data: [],
                // datos que deben aparecer seleccionados
                selectedData: [],
                // resultado
                result: [],
                update: false,
                validForm: false,
                enterpriseId: ''
            },
        },
        items: [],
        validationRules: {
            required: (value) => !!value || `${i18n.t("required")}`,
            greaterThanEqual(minValue) {
                return (value) =>
                    value === "" ||
                    value == null ||
                    minValue == null ||
                    Number(value) >= Number(minValue) ||
                    `${i18n.t("error.greaterThanEqual", {value: minValue})}`;
            },
            lessThanEqual(maxValue) {
                return (value) =>
                    value == null ||
                    maxValue == null ||
                    Number(value) <= Number(maxValue) ||
                    `${i18n.t('error.lessThanEqual', {value: maxValue})}`;
            },
            noDuplicateProperty: (allValues, value) =>
                !(allValues.filter((v) => v === value).length > 1) ||
                `${i18n.t("error.duplicateProperty")}`,
            shortDecimalNumber: (value) =>
                /^\d*(\.\d)?\d?$/.test(value) ||
                `${i18n.t('error.shortDecimalNumber', {value: value})}`,
            leftZeroNumber: (value) =>
                !/^0+(?!$)/.test(value) ||
                `${i18n.t('error.leftZeroNumber', {value: value})}`,
        },
        resetForms: false,
    }),
    computed: {},
    async beforeMount() {
        this.equipmentTab.model.selectedData = [];
        if (this.model.isSingleUpdate) {
            const rowData = {
                disabled: false,
                enterpriseId: this.model.selectedRowData[0].enterpriseId,
                groupId: this.model.selectedRowData[0].groupId,
                id: this.model.selectedRowData[0].id,
                name: this.model.selectedRowData[0].name,
                nodeType: 'THING'
            };
            this.equipmentTab.model.selectedData.push(rowData);
            this.items = [
                this.objectiveTab,
            ];
            this.objectiveTab.model.tableData = this.model.selectedRowData[0].objetivesTableData;

            this.equipmentTab.model.validForm = true;
        } else {
            this.model.enterpriseId = '';
            this.items = [
                this.objectiveTab,
                this.equipmentTab,
            ];
            this.equipmentTab.model.validForm = false;
        }
        this.getEnterpriseConfiguration(this.model.enterpriseId, this.model.typeId);
    },
    mounted() {
        if (this.model) {
            this.getEnterpriseConfiguration(
                this.model.enterpriseId,
                this.model.typeId
            );

            this.objectiveTab.model.name = this.model.name;
            this.objectiveTab.model.identificator = this.model.identificator;
            this.objectiveTab.model.color = this.model.color || "#0694de";
            this.objectiveTab.model.commodatum = this.model.commodatum;
            this.objectiveTab.model.disabled = !this.model.enterpriseId;

            if (this.model.isSingleUpdate) {
                this.getObjetiveTableData();
            }
        }
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions("breadcrumbs", ["pushBread", "pullBread"]),
        /**
         * actions del snackbar
         */
        ...mapActions("snackbar", ["showSnackbar", "closeSnackbar"]),
        /**
         * actions del dialog
         */
        ...mapActions("dialog", ["openDialog", "closeDialog"]),

        getObjetiveTableData() {
            this.objectiveTab.model.tableData = [];
            this.model.selectedRowData[0].stateTargets.forEach(data => this.objectiveTab.model.tableData.push({
                id: data.id,
                value: data.value
            }));
        },

        getEnterpriseConfiguration(enterpriseId, typeId) {
            if (enterpriseId && typeId) {
                thingService.getEnterpriseRusConfiguration(enterpriseId, typeId)
                    .then(response => this.rusTab.model.enterpriseRusConfigurations = response);
                thingService.getEnterpriseEventConfiguration(enterpriseId, typeId)
                    .then(response => this.eventTab.model.enterpriseEventConfiguration = response);
            }
        },
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            // para limpiar las validaciones en los formularios
            this.resetForms = true;
            Vue.nextTick(() => this.resetForms = false);
        },

        clickOutside() {
            this.cancel();
        },

        cancel() {
            this.pullBread(dialogTypes.THING.key);
            this.resetFields();
        },

        async save() {
            this.$emit('validateForm')
            let businessTargetDTO = null;
            let result = [];
            this.equipmentTab.model.selectedData.forEach((thing) => {
                    if (thing.children) {
                        thing.children.forEach(child => {
                            businessTargetDTO = {
                                thingId: child.id,
                                states: this.objectiveTab.model.tableData
                            }
                            result.push(businessTargetDTO);
                        })
                    } else {
                        businessTargetDTO = {
                            thingId: thing.id,
                            states: this.objectiveTab.model.tableData
                        }
                        result.push(businessTargetDTO);
                    }

                }
            );
            bussinesTargetService.createUpdateManyStateTarget(result).then(() => {
                this.showSnackbar({
                    visible: true,
                    text: this.$t('goals.successCreateMessage'),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS
                });

                this.cancel();
                this.$emit('commitThing');
            });
        },


    },
    watch: {
        'model.enterpriseId': {
            deep: true,
            immediate: true,
            handler: function (newValue) {
                this.objectiveTab.model.enterpriseId = newValue;
                this.equipmentTab.model.enterpriseId = newValue;
                this.objectiveTab.model.disabledBtn = !newValue && !this.model.isSingleUpdate;
            }
        }
    }
}
